import { onMounted, onUnmounted, ref } from 'vue'

export interface UseClockOptions {
  locale?: string
  interval?: number
}

export const useClock = (options: UseClockOptions = {}) => {
  const { locale = 'en-GB', interval = 5_000 } = options

  const formatDate = () =>
    new Intl.DateTimeFormat(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).format(Date.now())

  const formatTime = () =>
    new Intl.DateTimeFormat(locale, {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit'
    }).format(Date.now())

  const date = ref(formatDate())
  const time = ref(formatTime())
  let intervalId: number | undefined

  onMounted(() => {
    intervalId = window.setInterval(() => {
      date.value = formatDate()
      time.value = formatTime()
    }, interval)
  })

  onUnmounted(() => {
    window.clearInterval(intervalId)
  })

  return { date, time }
}
